import React from "react";
import Header from "./components/Header";
import ContactContent from "./components/Contact";
import Footer from "./components/Footer";
function Contact() {
  return (
    <div>
      <Header />
      <ContactContent />
      <Footer />
    </div>
  );
}
export default Contact;
